import { render, staticRenderFns } from "./Plant.vue?vue&type=template&id=0fad24a6&scoped=true"
import script from "./Plant.vue?vue&type=script&lang=ts"
export * from "./Plant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad24a6",
  null
  
)

export default component.exports